import { useEffect } from "react";
import "./styles.css";
import van from "/public/van_large.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useLeadForm } from "../../../context/leadform";

function MatchingStep() {
  const { step, setStep } = useLeadForm();
  useEffect(() => {
    setTimeout(function () {
      setStep(step + 1);
    }, 10000);
  }, []);
  return (
    <div className="Step MatchingStep">
      <h2>Finding cash house buyers suitable for your property</h2>
      <div className="MatchingContainer">
        <p>Finding cash house buyers...</p>
        <FontAwesomeIcon className="Spinner" icon={faSpinner} />
        <ul>
          <li>
            <FontAwesomeIcon icon={faCheck} />
            Checking property details
          </li>
          <li>
            <FontAwesomeIcon icon={faCheck} />
            Identifying active buyers
          </li>
          <li>
            <FontAwesomeIcon icon={faCheck} />
            Comparing buyer criteria
          </li>
          <li>
            <FontAwesomeIcon icon={faCheck} />
            Preparing your results
          </li>
        </ul>
        <img src={van} alt="van" />
        <p>
          We'll send full details by SMS once you've selected the buyer you'd
          like to contact.
        </p>
      </div>
    </div>
  );
}

export default MatchingStep;
